export const ROUTES_TO_HIDE_MENU_ON_NAVBAR = ['invitation', 'safecheck']

export const shouldShowMenus = (pathname: string) => {
    if (pathname === '/') return true

    const path = pathname.replace(/^\/([^/]*).*$/, '$1')

    return !ROUTES_TO_HIDE_MENU_ON_NAVBAR.find((route) => route.includes(path))
}
